import React from 'react';
import ServiceContent from 'components/root/terms/service/ServiceContent';

export const ServicePage: React.FC = () => {
  return <ServiceContent />;
};
